"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTranslations = void 0;
var _i18next = _interopRequireDefault(require("i18next"));
var _translation = _interopRequireDefault(require("./locales/en/translation"));
var _translation2 = _interopRequireDefault(require("./locales/es/translation"));
var _translation3 = _interopRequireDefault(require("./locales/fr/translation"));
var _translation4 = _interopRequireDefault(require("./locales/nl/translation"));
var _translation5 = _interopRequireDefault(require("./locales/pl/translation"));
var initTranslations = function initTranslations() {
  var instance = _i18next.default.createInstance();
  instance.init({
    fallbackLng: 'en',
    lng: getLanguageValue(),
    debug: false,
    interpolation: {
      escapeValue: false
    },
    resources: {
      en: {
        translation: _translation.default
      },
      es: {
        translation: _translation2.default
      },
      fr: {
        translation: _translation3.default
      },
      nl: {
        translation: _translation4.default
      },
      pl: {
        translation: _translation5.default
      }
    }
  });
  return instance;
};
exports.initTranslations = initTranslations;
var getLanguageValue = function getLanguageValue() {
  var language = localStorage.getItem('language');
  return language ? language.toLowerCase() : 'en';
};